/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as BrainsRouteImport } from './routes/brains'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as CreateRouteImport } from './routes/create'
import { Route as DeskRouteImport } from './routes/desk'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RiskRouteImport } from './routes/risk'
import { Route as RoomsRouteImport } from './routes/rooms'
import { Route as SearchRouteImport } from './routes/search'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAgentsRouteImport } from './routes/admin.agents'
import { Route as AdminFeesRouteImport } from './routes/admin.fees'
import { Route as AdminJobsRouteImport } from './routes/admin.jobs'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as ChallengesIndexRouteImport } from './routes/challenges.index'
import { Route as ChallengesIdRouteImport } from './routes/challenges.$id'
import { Route as DocsSupportRouteImport } from './routes/docs_.support'
import { Route as MeIndexRouteImport } from './routes/me.index'
import { Route as MeNotificationsRouteImport } from './routes/me.notifications'
import { Route as PassportIdRouteImport } from './routes/passport.$id'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio.index'
import { Route as PortfolioBillingRouteImport } from './routes/portfolio.billing'
import { Route as PortfolioShadowsRouteImport } from './routes/portfolio.shadows'
import { Route as PortfolioWalletRouteImport } from './routes/portfolio.wallet'
import { Route as RoomsIndexRouteImport } from './routes/rooms.index'
import { Route as RoomsRoomIdRouteImport } from './routes/rooms.$roomId'
import { Route as TokensIndexRouteImport } from './routes/tokens.index'
import { Route as TokensAddressRouteImport } from './routes/tokens.$address'
import { Route as UHandleRouteImport } from './routes/u.$handle'
import { Route as AHandleIndexRouteImport } from './routes/a.$handle.index'
import { Route as AHandleManageRouteImport } from './routes/a.$handle.manage'
import { Route as AHandleRemixRouteImport } from './routes/a.$handle.remix'
import { Route as ExternalClaimHandleRouteImport } from './routes/external.claim.$handle'
import { Route as RoomsInviteCodeRouteImport } from './routes/rooms_.invite.$code'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const BrainsRoute = BrainsRouteImport.update({
  id: '/brains',
  path: '/brains',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateRoute = CreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any)
const DeskRoute = DeskRouteImport.update({
  id: '/desk',
  path: '/desk',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskRoute = RiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsRoute = RoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAgentsRoute = AdminAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeesRoute = AdminFeesRouteImport.update({
  id: '/fees',
  path: '/fees',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const ChallengesIndexRoute = ChallengesIndexRouteImport.update({
  id: '/challenges/',
  path: '/challenges/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengesIdRoute = ChallengesIdRouteImport.update({
  id: '/challenges/$id',
  path: '/challenges/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsSupportRoute = DocsSupportRouteImport.update({
  id: '/docs_/support',
  path: '/docs/support',
  getParentRoute: () => rootRouteImport,
} as any)
const MeIndexRoute = MeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeNotificationsRoute = MeNotificationsRouteImport.update({
  id: '/me/notifications',
  path: '/me/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PassportIdRoute = PassportIdRouteImport.update({
  id: '/passport/$id',
  path: '/passport/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
  id: '/portfolio/',
  path: '/portfolio/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioBillingRoute = PortfolioBillingRouteImport.update({
  id: '/portfolio/billing',
  path: '/portfolio/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioShadowsRoute = PortfolioShadowsRouteImport.update({
  id: '/portfolio/shadows',
  path: '/portfolio/shadows',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioWalletRoute = PortfolioWalletRouteImport.update({
  id: '/portfolio/wallet',
  path: '/portfolio/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsIndexRoute = RoomsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RoomsRoute,
} as any)
const RoomsRoomIdRoute = RoomsRoomIdRouteImport.update({
  id: '/$roomId',
  path: '/$roomId',
  getParentRoute: () => RoomsRoute,
} as any)
const TokensIndexRoute = TokensIndexRouteImport.update({
  id: '/tokens/',
  path: '/tokens/',
  getParentRoute: () => rootRouteImport,
} as any)
const TokensAddressRoute = TokensAddressRouteImport.update({
  id: '/tokens/$address',
  path: '/tokens/$address',
  getParentRoute: () => rootRouteImport,
} as any)
const UHandleRoute = UHandleRouteImport.update({
  id: '/u/$handle',
  path: '/u/$handle',
  getParentRoute: () => rootRouteImport,
} as any)
const AHandleIndexRoute = AHandleIndexRouteImport.update({
  id: '/a/$handle/',
  path: '/a/$handle/',
  getParentRoute: () => rootRouteImport,
} as any)
const AHandleManageRoute = AHandleManageRouteImport.update({
  id: '/a/$handle/manage',
  path: '/a/$handle/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const AHandleRemixRoute = AHandleRemixRouteImport.update({
  id: '/a/$handle/remix',
  path: '/a/$handle/remix',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalClaimHandleRoute = ExternalClaimHandleRouteImport.update({
  id: '/external/claim/$handle',
  path: '/external/claim/$handle',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsInviteCodeRoute = RoomsInviteCodeRouteImport.update({
  id: '/rooms_/invite/$code',
  path: '/rooms/invite/$code',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/agents': typeof AgentsRoute
  '/brains': typeof BrainsRoute
  '/connect': typeof ConnectRoute
  '/create': typeof CreateRoute
  '/desk': typeof DeskRoute
  '/docs': typeof DocsRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/risk': typeof RiskRoute
  '/rooms': typeof RoomsRouteWithChildren
  '/search': typeof SearchRoute
  '/stats': typeof StatsRoute
  '/terms': typeof TermsRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/fees': typeof AdminFeesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/challenges/$id': typeof ChallengesIdRoute
  '/docs/support': typeof DocsSupportRoute
  '/me/notifications': typeof MeNotificationsRoute
  '/passport/$id': typeof PassportIdRoute
  '/portfolio/billing': typeof PortfolioBillingRoute
  '/portfolio/shadows': typeof PortfolioShadowsRoute
  '/portfolio/wallet': typeof PortfolioWalletRoute
  '/rooms/$roomId': typeof RoomsRoomIdRoute
  '/tokens/$address': typeof TokensAddressRoute
  '/u/$handle': typeof UHandleRoute
  '/admin/': typeof AdminIndexRoute
  '/challenges/': typeof ChallengesIndexRoute
  '/me/': typeof MeIndexRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/rooms/': typeof RoomsIndexRoute
  '/tokens/': typeof TokensIndexRoute
  '/a/$handle/manage': typeof AHandleManageRoute
  '/a/$handle/remix': typeof AHandleRemixRoute
  '/external/claim/$handle': typeof ExternalClaimHandleRoute
  '/rooms/invite/$code': typeof RoomsInviteCodeRoute
  '/a/$handle/': typeof AHandleIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/brains': typeof BrainsRoute
  '/connect': typeof ConnectRoute
  '/create': typeof CreateRoute
  '/desk': typeof DeskRoute
  '/docs': typeof DocsRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/risk': typeof RiskRoute
  '/search': typeof SearchRoute
  '/stats': typeof StatsRoute
  '/terms': typeof TermsRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/fees': typeof AdminFeesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/challenges/$id': typeof ChallengesIdRoute
  '/docs/support': typeof DocsSupportRoute
  '/me/notifications': typeof MeNotificationsRoute
  '/passport/$id': typeof PassportIdRoute
  '/portfolio/billing': typeof PortfolioBillingRoute
  '/portfolio/shadows': typeof PortfolioShadowsRoute
  '/portfolio/wallet': typeof PortfolioWalletRoute
  '/rooms/$roomId': typeof RoomsRoomIdRoute
  '/tokens/$address': typeof TokensAddressRoute
  '/u/$handle': typeof UHandleRoute
  '/admin': typeof AdminIndexRoute
  '/challenges': typeof ChallengesIndexRoute
  '/me': typeof MeIndexRoute
  '/portfolio': typeof PortfolioIndexRoute
  '/rooms': typeof RoomsIndexRoute
  '/tokens': typeof TokensIndexRoute
  '/a/$handle/manage': typeof AHandleManageRoute
  '/a/$handle/remix': typeof AHandleRemixRoute
  '/external/claim/$handle': typeof ExternalClaimHandleRoute
  '/rooms/invite/$code': typeof RoomsInviteCodeRoute
  '/a/$handle': typeof AHandleIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/agents': typeof AgentsRoute
  '/brains': typeof BrainsRoute
  '/connect': typeof ConnectRoute
  '/create': typeof CreateRoute
  '/desk': typeof DeskRoute
  '/docs': typeof DocsRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/risk': typeof RiskRoute
  '/rooms': typeof RoomsRouteWithChildren
  '/search': typeof SearchRoute
  '/stats': typeof StatsRoute
  '/terms': typeof TermsRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/fees': typeof AdminFeesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/challenges/$id': typeof ChallengesIdRoute
  '/docs_/support': typeof DocsSupportRoute
  '/me/notifications': typeof MeNotificationsRoute
  '/passport/$id': typeof PassportIdRoute
  '/portfolio/billing': typeof PortfolioBillingRoute
  '/portfolio/shadows': typeof PortfolioShadowsRoute
  '/portfolio/wallet': typeof PortfolioWalletRoute
  '/rooms/$roomId': typeof RoomsRoomIdRoute
  '/tokens/$address': typeof TokensAddressRoute
  '/u/$handle': typeof UHandleRoute
  '/admin/': typeof AdminIndexRoute
  '/challenges/': typeof ChallengesIndexRoute
  '/me/': typeof MeIndexRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/rooms/': typeof RoomsIndexRoute
  '/tokens/': typeof TokensIndexRoute
  '/a/$handle/manage': typeof AHandleManageRoute
  '/a/$handle/remix': typeof AHandleRemixRoute
  '/external/claim/$handle': typeof ExternalClaimHandleRoute
  '/rooms_/invite/$code': typeof RoomsInviteCodeRoute
  '/a/$handle/': typeof AHandleIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/agents'
    | '/brains'
    | '/connect'
    | '/create'
    | '/desk'
    | '/docs'
    | '/pricing'
    | '/privacy'
    | '/risk'
    | '/rooms'
    | '/search'
    | '/stats'
    | '/terms'
    | '/admin/agents'
    | '/admin/fees'
    | '/admin/jobs'
    | '/admin/users'
    | '/challenges/$id'
    | '/docs/support'
    | '/me/notifications'
    | '/passport/$id'
    | '/portfolio/billing'
    | '/portfolio/shadows'
    | '/portfolio/wallet'
    | '/rooms/$roomId'
    | '/tokens/$address'
    | '/u/$handle'
    | '/admin/'
    | '/challenges/'
    | '/me/'
    | '/portfolio/'
    | '/rooms/'
    | '/tokens/'
    | '/a/$handle/manage'
    | '/a/$handle/remix'
    | '/external/claim/$handle'
    | '/rooms/invite/$code'
    | '/a/$handle/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agents'
    | '/brains'
    | '/connect'
    | '/create'
    | '/desk'
    | '/docs'
    | '/pricing'
    | '/privacy'
    | '/risk'
    | '/search'
    | '/stats'
    | '/terms'
    | '/admin/agents'
    | '/admin/fees'
    | '/admin/jobs'
    | '/admin/users'
    | '/challenges/$id'
    | '/docs/support'
    | '/me/notifications'
    | '/passport/$id'
    | '/portfolio/billing'
    | '/portfolio/shadows'
    | '/portfolio/wallet'
    | '/rooms/$roomId'
    | '/tokens/$address'
    | '/u/$handle'
    | '/admin'
    | '/challenges'
    | '/me'
    | '/portfolio'
    | '/rooms'
    | '/tokens'
    | '/a/$handle/manage'
    | '/a/$handle/remix'
    | '/external/claim/$handle'
    | '/rooms/invite/$code'
    | '/a/$handle'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/agents'
    | '/brains'
    | '/connect'
    | '/create'
    | '/desk'
    | '/docs'
    | '/pricing'
    | '/privacy'
    | '/risk'
    | '/rooms'
    | '/search'
    | '/stats'
    | '/terms'
    | '/admin/agents'
    | '/admin/fees'
    | '/admin/jobs'
    | '/admin/users'
    | '/challenges/$id'
    | '/docs_/support'
    | '/me/notifications'
    | '/passport/$id'
    | '/portfolio/billing'
    | '/portfolio/shadows'
    | '/portfolio/wallet'
    | '/rooms/$roomId'
    | '/tokens/$address'
    | '/u/$handle'
    | '/admin/'
    | '/challenges/'
    | '/me/'
    | '/portfolio/'
    | '/rooms/'
    | '/tokens/'
    | '/a/$handle/manage'
    | '/a/$handle/remix'
    | '/external/claim/$handle'
    | '/rooms_/invite/$code'
    | '/a/$handle/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AgentsRoute: typeof AgentsRoute
  BrainsRoute: typeof BrainsRoute
  ConnectRoute: typeof ConnectRoute
  CreateRoute: typeof CreateRoute
  DeskRoute: typeof DeskRoute
  DocsRoute: typeof DocsRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  RiskRoute: typeof RiskRoute
  RoomsRoute: typeof RoomsRouteWithChildren
  SearchRoute: typeof SearchRoute
  StatsRoute: typeof StatsRoute
  TermsRoute: typeof TermsRoute
  ChallengesIdRoute: typeof ChallengesIdRoute
  DocsSupportRoute: typeof DocsSupportRoute
  MeNotificationsRoute: typeof MeNotificationsRoute
  PassportIdRoute: typeof PassportIdRoute
  PortfolioBillingRoute: typeof PortfolioBillingRoute
  PortfolioShadowsRoute: typeof PortfolioShadowsRoute
  PortfolioWalletRoute: typeof PortfolioWalletRoute
  TokensAddressRoute: typeof TokensAddressRoute
  UHandleRoute: typeof UHandleRoute
  ChallengesIndexRoute: typeof ChallengesIndexRoute
  MeIndexRoute: typeof MeIndexRoute
  PortfolioIndexRoute: typeof PortfolioIndexRoute
  TokensIndexRoute: typeof TokensIndexRoute
  AHandleManageRoute: typeof AHandleManageRoute
  AHandleRemixRoute: typeof AHandleRemixRoute
  ExternalClaimHandleRoute: typeof ExternalClaimHandleRoute
  RoomsInviteCodeRoute: typeof RoomsInviteCodeRoute
  AHandleIndexRoute: typeof AHandleIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brains': {
      id: '/brains'
      path: '/brains'
      fullPath: '/brains'
      preLoaderRoute: typeof BrainsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desk': {
      id: '/desk'
      path: '/desk'
      fullPath: '/desk'
      preLoaderRoute: typeof DeskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk': {
      id: '/risk'
      path: '/risk'
      fullPath: '/risk'
      preLoaderRoute: typeof RiskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms': {
      id: '/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof RoomsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/agents': {
      id: '/admin/agents'
      path: '/agents'
      fullPath: '/admin/agents'
      preLoaderRoute: typeof AdminAgentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fees': {
      id: '/admin/fees'
      path: '/fees'
      fullPath: '/admin/fees'
      preLoaderRoute: typeof AdminFeesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs': {
      id: '/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/challenges/': {
      id: '/challenges/'
      path: '/challenges'
      fullPath: '/challenges/'
      preLoaderRoute: typeof ChallengesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges/$id': {
      id: '/challenges/$id'
      path: '/challenges/$id'
      fullPath: '/challenges/$id'
      preLoaderRoute: typeof ChallengesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs_/support': {
      id: '/docs_/support'
      path: '/docs/support'
      fullPath: '/docs/support'
      preLoaderRoute: typeof DocsSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/': {
      id: '/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof MeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/notifications': {
      id: '/me/notifications'
      path: '/me/notifications'
      fullPath: '/me/notifications'
      preLoaderRoute: typeof MeNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passport/$id': {
      id: '/passport/$id'
      path: '/passport/$id'
      fullPath: '/passport/$id'
      preLoaderRoute: typeof PassportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/': {
      id: '/portfolio/'
      path: '/portfolio'
      fullPath: '/portfolio/'
      preLoaderRoute: typeof PortfolioIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/billing': {
      id: '/portfolio/billing'
      path: '/portfolio/billing'
      fullPath: '/portfolio/billing'
      preLoaderRoute: typeof PortfolioBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/shadows': {
      id: '/portfolio/shadows'
      path: '/portfolio/shadows'
      fullPath: '/portfolio/shadows'
      preLoaderRoute: typeof PortfolioShadowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/wallet': {
      id: '/portfolio/wallet'
      path: '/portfolio/wallet'
      fullPath: '/portfolio/wallet'
      preLoaderRoute: typeof PortfolioWalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms/': {
      id: '/rooms/'
      path: '/'
      fullPath: '/rooms/'
      preLoaderRoute: typeof RoomsIndexRouteImport
      parentRoute: typeof RoomsRoute
    }
    '/rooms/$roomId': {
      id: '/rooms/$roomId'
      path: '/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof RoomsRoomIdRouteImport
      parentRoute: typeof RoomsRoute
    }
    '/tokens/': {
      id: '/tokens/'
      path: '/tokens'
      fullPath: '/tokens/'
      preLoaderRoute: typeof TokensIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tokens/$address': {
      id: '/tokens/$address'
      path: '/tokens/$address'
      fullPath: '/tokens/$address'
      preLoaderRoute: typeof TokensAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$handle': {
      id: '/u/$handle'
      path: '/u/$handle'
      fullPath: '/u/$handle'
      preLoaderRoute: typeof UHandleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$handle/': {
      id: '/a/$handle/'
      path: '/a/$handle'
      fullPath: '/a/$handle/'
      preLoaderRoute: typeof AHandleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$handle/manage': {
      id: '/a/$handle/manage'
      path: '/a/$handle/manage'
      fullPath: '/a/$handle/manage'
      preLoaderRoute: typeof AHandleManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$handle/remix': {
      id: '/a/$handle/remix'
      path: '/a/$handle/remix'
      fullPath: '/a/$handle/remix'
      preLoaderRoute: typeof AHandleRemixRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/claim/$handle': {
      id: '/external/claim/$handle'
      path: '/external/claim/$handle'
      fullPath: '/external/claim/$handle'
      preLoaderRoute: typeof ExternalClaimHandleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms_/invite/$code': {
      id: '/rooms_/invite/$code'
      path: '/rooms/invite/$code'
      fullPath: '/rooms/invite/$code'
      preLoaderRoute: typeof RoomsInviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminAgentsRoute: typeof AdminAgentsRoute
  AdminFeesRoute: typeof AdminFeesRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAgentsRoute: AdminAgentsRoute,
  AdminFeesRoute: AdminFeesRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface RoomsRouteChildren {
  RoomsRoomIdRoute: typeof RoomsRoomIdRoute
  RoomsIndexRoute: typeof RoomsIndexRoute
}

const RoomsRouteChildren: RoomsRouteChildren = {
  RoomsRoomIdRoute: RoomsRoomIdRoute,
  RoomsIndexRoute: RoomsIndexRoute,
}

const RoomsRouteWithChildren = RoomsRoute._addFileChildren(RoomsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AgentsRoute: AgentsRoute,
  BrainsRoute: BrainsRoute,
  ConnectRoute: ConnectRoute,
  CreateRoute: CreateRoute,
  DeskRoute: DeskRoute,
  DocsRoute: DocsRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  RiskRoute: RiskRoute,
  RoomsRoute: RoomsRouteWithChildren,
  SearchRoute: SearchRoute,
  StatsRoute: StatsRoute,
  TermsRoute: TermsRoute,
  ChallengesIdRoute: ChallengesIdRoute,
  DocsSupportRoute: DocsSupportRoute,
  MeNotificationsRoute: MeNotificationsRoute,
  PassportIdRoute: PassportIdRoute,
  PortfolioBillingRoute: PortfolioBillingRoute,
  PortfolioShadowsRoute: PortfolioShadowsRoute,
  PortfolioWalletRoute: PortfolioWalletRoute,
  TokensAddressRoute: TokensAddressRoute,
  UHandleRoute: UHandleRoute,
  ChallengesIndexRoute: ChallengesIndexRoute,
  MeIndexRoute: MeIndexRoute,
  PortfolioIndexRoute: PortfolioIndexRoute,
  TokensIndexRoute: TokensIndexRoute,
  AHandleManageRoute: AHandleManageRoute,
  AHandleRemixRoute: AHandleRemixRoute,
  ExternalClaimHandleRoute: ExternalClaimHandleRoute,
  RoomsInviteCodeRoute: RoomsInviteCodeRoute,
  AHandleIndexRoute: AHandleIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
